import _ from 'lodash';
import api from "../../../api/catalogs/failure_scheduled.js";
import apiAuth from "../../../api/catalogs/failure_scheduled_auth.js";

const namespaced = true;

const state = {
    failure_scheduled_data: [],
    auth_loading : false,
    loading : false,
};
const mutations = {
    SET_FAILURE_SCHEDULED(state, data) {
        state.failure_scheduled_data = data;
    },
    SET_AUTH_LOADING(state, data) {
        state.auth_loading = data;
    },
    SET_LOADING(state, data) {
        state.loading = data;
    },
    ADD_FAILURE_SCHEDULED(state, value) {
        state.failure_scheduled_data.push(value);
    },
    UPDATE_FAILURE_SCHEDULED(state, value) {
           const newArr = _.clone(state.failure_scheduled_data);
           const index = _.findIndex(state.failure_scheduled_data, function (o) {
               return o.id == value.failure_scheduled_id;
           });
           if (index !== -1) {
               let failure_tempo = newArr[index]
               failure_tempo.status_id = value.failure_scheduled.status_id
               failure_tempo.validations.push(value);
               newArr[index] = failure_tempo;
           }
      
           state.failure_scheduled_data = newArr;
    },
};
const actions = {
    getFailureScheduled(context, all = false) {
        context.commit("SET_LOADING",true);
        return new Promise((resolve) => {
            api.getFailureScheduled(all)
                .then(function (res) {
                    context.commit("SET_FAILURE_SCHEDULED", res.data.data);
                    resolve(res.data);
                    context.commit("SET_LOADING",false);
                })
                .catch(function (error) {
                    console.log(error);
                    context.commit("SET_LOADING",false);
                });
        });
    },
    store(context, data) {
        return new Promise((resolve) => {
            api.store(data)
                .then(function (res) {
                    context.commit("ADD_FAILURE_SCHEDULED", res.data.data);
                    context.dispatch(
                        "notifications/add",
                        {
                            color: "success",
                            visibility: true,
                            timeout: 5000,
                            text: res.data.message,
                        },
                        { root: true }
                    );
                    resolve(res.data);
                })
                .catch(function (error) {
                    console.log(error);
                });
        });
    },
    auth(context, data) {
        context.commit("SET_AUTH_LOADING",true);
        return new Promise((resolve) => {
            apiAuth
                .auth(data)
                .then(function (res) {
                    context.commit("UPDATE_FAILURE_SCHEDULED", res.data.data);
                    context.dispatch(
                        "notifications/add",
                        {
                            color: "success",
                            visibility: true,
                            timeout: 5000,
                            text: res.data.message,
                        },
                        { root: true }
                    );
                    resolve(res.data);
                    context.commit("SET_AUTH_LOADING",false);
                })
                .catch(function (error) {
                    context.dispatch(
                        "notifications/add",
                        {
                            color: "error",
                            visibility: true,
                            timeout: 5000,
                            text: error.messages,
                        },
                        { root: true }
                    );
                    context.commit("SET_AUTH_LOADING",false);
                });
        });
    },
};

const getters = {
    getFailureScheduledAuth(state, getters, rootState) {
        let tempo = _.filter(state.failure_scheduled_data, ['status_id', 1])
        return _.orderBy(
            _.filter(tempo, (item) =>  _.some(item.validations,(validation) =>validation.user_id === rootState.configuration.userAuth.id) ), ["id"],["desc"]
        );
    },
    getFailureScheduledNoAuth(state) {
        return _.orderBy( _.filter(state.failure_scheduled_data, ['status_id', 1]), ["id"],["desc"])
        
    },
    getFailureScheduledAuthByEvent(state) {
        return _.map(_.sortBy(_.filter(state.failure_scheduled_data,['status_id',3]), 'description'),'description');
    },
    getFailuresScheduled(state) {
        return  _.filter(state.failure_scheduled_data, ['status_id', 3])
    },
};

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
};
